import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";

const faqData = [
  {
    question: "¿Cómo puede la IA ayudar a mi negocio?",
    answer: "La IA automatiza tareas repetitivas, mejora la atención al cliente 24/7 y analiza datos para tomar mejores decisiones, ahorrándote tiempo y dinero."
  },
  {
    question: "¿Cuánto tiempo tarda en implementarse una solución?",
    answer: "Depende de la complejidad. Un chatbot puede estar listo en 1-2 semanas, mientras que un SaaS a medida puede llevar 4-8 semanas. Siempre definimos plazos claros antes de empezar."
  },
  {
    question: "¿Necesito conocimientos técnicos?",
    answer: "No. Nosotros nos encargamos de toda la parte técnica. Te entregamos herramientas listas para usar y te formamos para que saques el máximo provecho."
  },
  {
    question: "¿Es seguro integrar IA en mi empresa?",
    answer: "Absolutamente. Priorizamos la seguridad y privacidad de tus datos, utilizando protocolos de encriptación y cumpliendo con las normativas vigentes."
  },
  {
    question: "¿Ofrecéis soporte después del lanzamiento?",
    answer: "Sí, ofrecemos planes de mantenimiento y soporte continuo para asegurar que todo funcione perfectamente y adaptar las soluciones a medida que tu negocio crece."
  },
  {
    question: "¿Qué diferencia a Skyrocket AI de otras agencias?",
    answer: "No solo entregamos tecnología, entregamos resultados. Nuestro enfoque es 100% comercial y estratégico, asegurando que cada implementación tenga un retorno de inversión claro."
  }
];

export const FAQ = () => {
  return (
    <section className="pt-48 pb-32 px-6 max-w-4xl mx-auto z-10 relative min-h-screen">
       <div className="absolute inset-0 grid-overlay opacity-40 pointer-events-none z-0"></div>
       <div className="relative z-10 text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-bold mb-6">Preguntas <span className="text-nebula-gold">Frecuentes</span></h2>
          <p className="text-white/50 text-lg max-w-2xl mx-auto">Resolvemos tus dudas sobre cómo llevamos tu negocio al siguiente nivel con tecnología de vanguardia.</p>
       </div>

       <div className="relative z-10 space-y-4">
         <Accordion type="single" collapsible className="w-full">
           {faqData.map((item, index) => (
             <AccordionItem key={index} value={`item-${index}`} className="border border-white/10 bg-white/[0.02] rounded-2xl px-6 mb-4 overflow-hidden backdrop-blur-sm transition-all duration-300 hover:border-nebula-gold/30 hover:bg-white/[0.04]">
               <AccordionTrigger className="text-white hover:text-nebula-gold text-lg font-bold text-left py-6">
                 {item.question}
               </AccordionTrigger>
               <AccordionContent className="text-white/60 text-base leading-relaxed pb-6 pr-8">
                 {item.answer}
               </AccordionContent>
             </AccordionItem>
           ))}
         </Accordion>
       </div>
    </section>
  );
};
